var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"sw-Loading"},[_c('img',{staticClass:"sw-Loading_Img sw-Loading_Icon",attrs:{"src":require("common/loading.svg"),"alt":"商品情報を読み込んでいます"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }